module.exports = __webpack_public_path__ + "media/bootstrap-icons/ladder-2af43eea.svg";